import CancelablePromise from 'mn-utils/CancelablePromise';
import {apiRequest} from '../../ws';
import {TCurrency, TFilter, TList, TUUID} from '@/types';
import {TCreateParams, TListItem} from './types';
import {getWithdrawDetails, getWithdrawList} from './mock';

import {
  ENDPOINT_MERCHANT_WD_CREATE,
  ENDPOINT_MERCHANT_SC_WD_CREATE,
  ENDPOINT_MERCHANT_WD_LIST,
  ENDPOINT_MERCHANT_WD_GET
} from '../../../constants/api';

export function apiV2WithdrawFiatCreate(params: TCreateParams): Promise<{id: TUUID}> {
  const url = ENDPOINT_MERCHANT_WD_CREATE;
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequest(url, params);
}

export function apiV2WithdrawCryptoCoinCreate(params: TCreateParams): Promise<{id: TUUID}> {
  const url = ENDPOINT_MERCHANT_SC_WD_CREATE;
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequest(url, params);
}

export function apiV2WithdrawList(params: TFilter<TListItem, {amount_currency: TCurrency}>): Promise<TList<TListItem>> {
  const url = ENDPOINT_MERCHANT_WD_LIST;

  // console.log(params);

  params = params || {};
  params.offset = params.offset || 0;
  params.limit = params.limit || 50;

  if (process.env.MOCK) {
    const response = {
      list: getWithdrawList(params.limit),
      count: params.limit * 10,
    };
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequest(url, params);
}

export function apiV2WithdrawGet(params: {id: TUUID}): Promise<TListItem> {
  const url = ENDPOINT_MERCHANT_WD_GET;
  if (process.env.MOCK) {
    const response = getWithdrawDetails();
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequest(url, params);
}
